<template>
  <div class="general-view profile">
    <div class="fixed-bar">
      <Headline />
      <section class="action-bar light">
        <div class="content-wrap">
          <a class="btn-back" @click="$router.back()">
            <span class="icon-back"></span>
            {{ $t("user.back") }}
          </a>
        </div>
      </section>
    </div>

    <div class="profile-box shadow">
      <div class="columns">
        <label class="column is-one-third">{{ $t("user.username") }}</label>
        <span class="column dynatrace" id="user_id">{{ $store.state.userStore.user_name }}</span>
      </div>
      <div class="columns">
        <label class="column is-one-third">{{ $t("user.email") }}</label>
        <span class="column">{{ $store.state.userStore.email }}</span>
      </div>
      <div class="columns">
        <label class="column is-one-third">{{ $t("user.role") }}</label>
        <span class="column dynatrace" id="role">
          {{ $store.state.userStore.displayRoles[$store.state.userStore.role] }}
        </span>
      </div>
      <div class="columns">
        <label class="column is-one-third">{{ $t("user.organization") }}</label>
          <span class="column dynatrace" id="compagny">{{ $store.state.userStore.organization }}</span>
      </div>
      <div class="columns">
        <label class="column is-one-third">{{ $t("user.lang") }}</label>
        <span class="column">
          <Multiselect v-model="multielectValue" :customLabel="getCustomLabel" :options="langOptions" :searchable="false"
            :reset-after="false" :show-labels="false" :allowEmpty="false" @select="confirmChooseLang()" />
        </span>
      </div>
      <div class="columns">
        <label class="column is-one-third">Timezone:</label>
          <span class="column dynatrace" id="compagny">{{ timeZone }}</span>
      </div>

     <div v-if="!isAHAdmin">
        <div class="columns">
          <label class="column is-one-third">APP version:</label>
          <span class="column dynatrace" id="app_version_id">{{ version }}</span>
        </div>
        <div class="columns">
          <label class="column is-one-third">API version:</label>
          <span class="column dynatrace" id="api_version_id">{{ api_info["version"] }}</span>
        </div>
        <div class="columns">
          <label class="column is-one-third">Ground version:</label>
          <span class="column dynatrace" id="ground_version_id">{{ ground_info["version"] }}</span>
        </div>
      </div>

     <table v-if="isAHAdmin">
        <tr>
          <th>Module</th>
          <th>Version</th>
          <th>Commit ID</th>
          <th>Build Date</th>
          <th>Build Number</th>
          <th>CICD Version</th>
        </tr>
        <tr>
          <td>APP</td>
          <td>{{ version }}</td>
          <td>{{ truncCommitId(commitid) }}</td>
          <td :title="formatDateAndTime(buildDate, true)">{{ formatDateAndTime(buildDate, false) }}</td>
          <td>{{ buildNumber }}</td>
          <td :title="appCicdCommit">{{ appCicdVersion }}</td>
        </tr>
        <tr>
          <td>API</td>
          <td>{{ api_info["version"] }}</td>
          <td>{{ truncCommitId(api_info["commit_id"]) }}</td>
          <td :title="formatDateAndTime(api_info['build_date'], true)">{{ formatDateAndTime(api_info["build_date"], false) }}</td>
          <td>{{ api_info["build_number"] }}</td>
          <td :title="api_info['cicd_commit']">{{ api_info["cicd_version"] }}</td>
        </tr>
        <tr>
          <td>Ground</td>
          <td>{{ ground_info["version"] }}</td>
          <td>{{ truncCommitId(ground_info["commit_id"]) }}</td>
          <td :title="formatDateAndTime(ground_info['build_date'], true)">{{ formatDateAndTime(ground_info["build_date"], false) }}</td>
          <td>{{ ground_info["build_number"] }}</td>
          <td :title="ground_info['cicd_commit']">{{ ground_info["cicd_version"] }}</td>
        </tr>
      </table>

    </div>

    <modal :modalName="confirmLanguageModal.name" width="430px">
      <ModalConfirm :message="confirmLanguageModal.message" :cancel="true" @modalConfirmed="chooseLang()" />
    </modal>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import NavLayout from "@/layouts/NavLayout";
import Headline from "../components/Headline";
import Modal from "../components/modals/Modal";
import ModalConfirm from "../components/modals/ModalConfirm";
import { DateService } from "../utils/dateService";

export default {
  components: {
    Headline,
    Modal,
    ModalConfirm,
  },
  data() {
    const version = window.env.VUE_APP_CURRENT_BRANCH || 'v0.0.0';
    return {
      multielectValue: this.$i18n.locale,
      langOptions: ["en", "fr", "de"],
      confirmLanguageModal: {
        name: "confirmChangeLanguadgeModal",
        message: this.$t("confirmLanguageModal.message"),
      },
      organization: "",
      version: version.includes("/") ? version.split("/")[1] : version,
      buildNumber: window.env.VUE_APP_BUILD_NUMBER || "N/A",
      commitid: window.env.VUE_APP_COMMIT_ID || "N/A",
      buildDate: window.env.VUE_APP_BUILD_DATE || "N/A",
      appCicdVersion: window.env.VUE_APP_CICD_VERSION || "N/A",
      appCicdCommit: window.env.VUE_APP_CICD_COMMIT_ID || "N/A",
      api_info: {
        version: "N/A",
        commit_id: "N/A",
        build_date: null,
        build_number: "N/A",
        cicd_commit: "N/A",
        cicd_version: "N/A"
      },
      ground_info: {
        version: "N/A",
        commit_id: "N/A",
        build_date: null,
        build_number: "N/A",
        cicd_commit: "N/A",
        cicd_version: "N/A"
      }
    };
  },

  computed: {
    ...mapState(["userStore"]),
    ...mapGetters('userStore', ['isAHAdmin']),
    user() {
      return this.userStore;
    },
    timeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone + " " + this.$moment().format('[UTC]Z');
    }
  },
  created() {
    this.$emit("update:layoutComponent", NavLayout);

    this.$requester
      .get(`/versions`)
      .then(response => {
        if (response.data) {
          try {
            this.api_info = response.data["api"];
            this.ground_info = response.data["ground"];
          }
          catch (error) {
            console.log(error);
          }
        }
      })
      .catch(error => {
        console.log("Error calling endpoint /versions:", error);
      });
  },
  methods: {
    ...mapActions("appStore", ["changeLanguage", "openModal", "closeModal"]),
    getCustomLabel(lang) {
      return this.$t(`language.${lang}`);
    },
    confirmChooseLang() {
      this.openModal(this.confirmLanguageModal.name);
    },
    chooseLang() {
      this.changeLanguage(this.multielectValue);
      this.closeModal();
    },
    truncCommitId(id) {
      if (id && id.length > 7) {
        return id.substring(0, 7);
      }
      return id;
    },
    formatDateAndTime(time, utcOffset) {
      return DateService.formatDateAndTime(this.$moment, time, utcOffset);
    }
  },
};
</script>
